import React from 'react'
import '../Results.css'
import Drawer from './Drawer'
import Card from './Card'

function createOptionsSearchContext(values, department) {
  var options = []
  console.log('Department:', department)

  const searchContextOptions = {
    document: { value: 'document', text: 'Document Search' },
    sql: { value: 'sql', text: 'Data search' },
    translate: { value: 'translate', text: 'Translate' },
    web: { value: 'web', text: 'Web' }
  }

  for (let i = 0; i < values.length; i++) {
    if (department === 'Basic' && values[i] === 'document') {
      var col = { value: 'document', text: 'ChatGPT' }
    } else {
      var col = searchContextOptions[values[i]]
    }
    // var col = searchContextOptions[values[i]]
    options.push(col)
  }
  console.log('This is my options:', options)
  return options
}

function createOptionsLLM(values) {
  var options = []

  const llmOptions = {
    'gpt-4o': { value: 'gpt-4o', text: 'GPT-4o' },
    'gpt-4o-mini': { value: 'gpt-4o-mini', text: 'GPT-4o Mini' }
  }

  for (let i = 0; i < values.length; i++) {
    var col = llmOptions[values[i]]
    if (col !== undefined) {
      options.push(col)
    }
  }
  console.log('Options:')
  console.log(options)
  return options
}

const SettingsDrawer = ({
  isDrawerOpen,
  closeDrawer,
  showSearchContextOptions,
  searchContext,
  handleSearchContext,
  model,
  handleModel,
  showModel,
  adminConfig,
  handleAnalyze,
  system_message_temp,
  handleSystemMessageChange,
  handleSaveSystemMessage,
  handleSaveSystemMessageReset,
  unsaved,
  handleTemp,
  showSystemMessage,
  showTemperature,
  sessions,
  id,
  userMail,
  index,
  handleDelete,
  handleSessionChange,
  sessionDropdownDisabled,
  deleteDisabled,
  temperature
}) => {
  return (
    <Drawer isOpen={isDrawerOpen} onClose={closeDrawer} title="Settings" icon="settings">
      <div className="settings-drawer">
        <div className="search-context-container">
          <one-ux-radio-group
            label="Search"
            disabled={!showSearchContextOptions}
            value={searchContext}
            options={createOptionsSearchContext(adminConfig.allowedSearchContext, index)}
            radio-position="before-text"
            required
            columns="1"
            implicit
            onChange={handleSearchContext}></one-ux-radio-group>

          <one-ux-radio-group
            label="LLM"
            disabled={!showModel}
            class="model-radio-group"
            value={model}
            options={createOptionsLLM(adminConfig.allowedLLMs)}
            radio-position="before-text"
            required
            columns="1"
            implicit
            onChange={handleModel}></one-ux-radio-group>

          <one-ux-button
            disable="showSearchContextOptions"
            label="Open Analyze"
            onClick={handleAnalyze}
            disabled={!adminConfig.analyze}></one-ux-button>
        </div>

        {adminConfig.allowedChangingSM && (
          <div className="system-message-container">
            <one-ux-field label="System Prompt">
              <one-ux-textarea
                disabled={!showSystemMessage}
                line-count="4"
                placeholder="Type your system message here"
                value={system_message_temp}
                onInput={handleSystemMessageChange}></one-ux-textarea>
            </one-ux-field>

            <div className="system-message-buttons">
              <one-ux-button
                label="Save"
                disabled={!showSystemMessage || !unsaved}
                purpose="main"
                onClick={handleSaveSystemMessage}></one-ux-button>

              <one-ux-button
                label="Reset"
                disabled={!showSystemMessage}
                implicit
                onClick={handleSaveSystemMessageReset}></one-ux-button>
            </div>
          </div>
        )}

        {adminConfig.showTemperature && (
          <one-ux-radio-group
            label="Temperature"
            value={temperature}
            options={[
              { value: 0.3, text: 'Very Strict' },
              { value: 0.5, text: 'Strict' },
              { value: 0.7, text: 'Balanced' },
              { value: 0.9, text: 'Creative' },
              { value: 1.1, text: 'Very Creative' }
            ]}
            radio-position="before-text"
            required
            columns="2"
            onChange={handleTemp}></one-ux-radio-group>
        )}

        <div class="one-ux-typography--heading-400">Previous Conversations</div>
        <one-ux-scroll
          class="session-scroll"
          style={{
            pointerEvents: !sessionDropdownDisabled ? 'auto' : 'none',
            cursor: !sessionDropdownDisabled ? 'pointer' : 'default',
            opacity: sessionDropdownDisabled ? 0.2 : 1
          }}>
          <div class="sessions">
            {sessions.map((session, index) => (
              <Card
                title={session.summary}
                date={new Date(session.timestamp * 1000).toISOString().split('T')[0]}
                DeleteClick={(event) => {
                  event.stopPropagation()
                  !deleteDisabled && handleDelete(session.id)
                }}
                SelectClick={() => !sessionDropdownDisabled && handleSessionChange(session.id)}
                key={index}></Card>
            ))}
          </div>
        </one-ux-scroll>

        <div class="settings-footer">
          <one-ux-icon icon="info" set="default" size="300"></one-ux-icon>

          <div className="tooltip-info">
            <p>Session Id: {id}</p>
            <p>Authenticated user: {userMail}</p>
            <p>Model: {index}</p>
          </div>
        </div>
      </div>
    </Drawer>
  )
}

export default SettingsDrawer
